import type { ReactNode } from 'react';
import waveUrl from './svg/Wave.svg';

export function AuthShell({ children }: { children: ReactNode }) {
  return (
    <div className="bg-bg relative flex min-h-full items-center justify-center overflow-hidden px-6 py-20">
      <img
        src={waveUrl}
        alt=""
        aria-hidden="true"
        decoding="async"
        fetchPriority="low"
        className="pointer-events-none absolute inset-0 h-full w-full object-cover select-none"
      />
      <div className="bg-bg-elevated/80 relative w-full max-w-md rounded-lg border border-white/8 px-10 py-12 backdrop-blur-sm">
        {children}
      </div>
    </div>
  );
}
